import {SpyneAppProperties, SpyneTrait} from 'spyne';
import { Auth0Client } from '@auth0/auth0-spa-js';
import {LocalStorageTraits} from 'traits/local-storage-traits';
import {StageViewAuthLinks} from 'components/stage-view-auth-links';

const updateTOSURL = "https://h46farkdhlzyo3cuysc25yyjtu0ufobh.lambda-url.us-east-1.on.aws/";

const stripeCheckoutSessionURL = "https://tl6w2xrvjrdpkvlwpo2ncpmzze0ymrih.lambda-url.us-east-1.on.aws/";

const stripeManageSettingsURL = "https://het5khl3rhziy4t6jg2ueiymnm0xrexh.lambda-url.us-east-1.on.aws/";
const stripeWebhookURL = "https://3udtkca5l24vl5obg7zttzq2ra0vvkab.lambda-url.us-east-1.on.aws/";
const stripeGetSubscriptionInfo = "https://ydn5kupwfg3cpxd2xplcclmeyy0zaipc.lambda-url.us-east-1.on.aws/";


export class StageViewAuthLinkTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "stageAuth$";

    super(context, traitPrefix);

    /**
     *
     * 1. New User -> Free            FREE-PATH
     * 2. New User -> Pro             FREE-PATH / PRO-PATH
     * 3. New User -> Enterprise      ENTERPRISE-CALENDLY
     *
     * 4. Free -> Free                REDUNDANT-CHECK-MESSAGE
     * 5. Free -> Pro                 PRO-PATH
     * 6. Free -> Enterprise          ENTERPRISE-CALENDLY-CUSTOM
     *
     * 7. Pro -> Free                 REDUNDANT-CHECK-MESSAGE
     * 8. Pro -> Pro                  REDUNDANT-CHECK-MESSAGE
     * 9. Pro -> Enterprise           ENTERPRISE-CALENDLY-CUSTOM
     *
     * 10. Enterprise -> Free         NON-EXISTENT
     * 11. Enterprise -> Pro          NON-EXISTENT
     * 12. Enterprise -> Enterprise   NON-EXISTENT
     *
     * ----------------------------------------------
     *
     * LOGINS
     *    NEW      -> FREE
     *    NEW      -> FREE -> PRO
     *    FREE     -> PRO
     *
     * STRIPE
     *    FREE     -> PRO
     *
     * MESSAGES
     *    UPGRADE
     *      NEW    -> FREE RETURN
     *
     *    SUCCESS
     *      NEW    -> FREE
     *      FREE   -> PRO
     *
     *    REDUNDANT
     *      FREE   -> FREE ----> Login
     *      PRO    -> FREE ----> data-pricing-event="manageSettings"
     *
     * CALENDLY
     *      NEW    -> NON-PERSONAL
     *      FREE   -> PERSONAL
     *      PRO    -> PERSONAL
     *
     *
     *
     *
     *
     *
     * */



  }

  static stageAuth$OnCalendleyEvent(e){
    window.open("https://calendly.com/frank-spynejs/30min", "_blank", "noopener,noreferrer");
  }


  static async stageAuth$OnManageSettingsEvent(e){
    const {isAuthenticated, auth0, userProfile, userRecord} = this.props;


    if (!isAuthenticated) {
      // Redirect to Auth0, tell it to come back and continue upgrade

      localStorage.setItem("postAuthIntent", "manageSettings");
      const redirect_uri = `${window.location.origin}#/callback`;

      auth0.loginWithRedirect({
        authorizationParams: {
          redirect_uri
        }});


    } else {
      this.setTempToken(e);
      const stageToken = SpyneAppProperties.getProp('stageToken');

      await this.stageAuth$StartManageSettingsFlow(stageToken);



    }

  }

  static stageAuth$SendMessageRequestEvent(role='free'){
    const title = "You already have a Pro Account."
    const desc = "";
    const iconClass = "fa-circle-info";

    const action = "CHANNEL_MODAL_WINDOW_MESSAGE_REQUEST_EVENT";

    this.sendInfoToChannel("CHANNEL_MODAL_WINDOW", {title, desc, iconClass, action}, action);



  }

  static async stageAuth$OnPricingEvent(e){

    const {isAuthenticated, auth0, userProfile, userRecord} = this.props;


    if (!isAuthenticated) {
      // Redirect to Auth0, tell it to come back and continue upgrade

      localStorage.setItem("postAuthIntent", "upgrade_pro");
      const redirect_uri = `${window.location.origin}#/callback`;

      auth0.loginWithRedirect({
        authorizationParams: {
          redirect_uri
        }});


    } else {
        this.setTempToken(e);
        const stageToken = SpyneAppProperties.getProp('stageToken');
        localStorage.setItem("postAuthIntent", "upgrade_pro_validate");

        await this.stageAuth$StartUpgradeFlow(stageToken);



      }




  }

  static stageAuth$OnEnterprisClick(e) {

    /*    <a href="mailto:sales@spynejs.com
    ?subject=Enterprise%20Inquiry%20-%20SpyneJS
    &body=Hi%20SpyneJS%20team,%0D%0A%0D%0AI'm%20interested%20in%20the%20Enterprise%20plan.%20Here%20are%20my%20details:%0D%0A-%20Company%20Name:%0D%0A-%20Team%20Size:%0D%0A-%20Use%20Case:%0D%0A%0D%0AThanks!">
          <button>Contact Sales</button>
        </a>*/

/*    <button
        onClick="window.location.href='https://calendly.com/frankbatista/spynejs-enterprise'">
      Talk to the Founder
    </button>;*/

  }

  static async stageAuth$StartUpgradeProcess() {
    const {auth0} = this.props;
    const isAuth = await auth0.isAuthenticated();

    if (!isAuth) {
      return auth0.loginWithRedirect({
        appState: { postLoginAction: "upgrade_pro" }
      });
    }

    // Otherwise begin Stripe upgrade flow
    //stageAuth$StartUpgradeFlow();
  }

  static async stageAuth$CallbackHandler(){
    const {auth0} = this.props;

    // After Auth0 redirect


    try {
      const result = await auth0.handleRedirectCallback();
    } catch (e) {
      if (e.message.includes("Issuer (iss) claim mismatch")) {

        console.warn("Clearing stale Auth0 tokens…");
        Object.keys(localStorage).forEach(key => {
          if (key.includes('auth0') || key.includes('@@auth0spajs')) {
            localStorage.removeItem(key);
          }
        });
        sessionStorage.clear();

        window.location.href = "/";
        return;
      }

      // rethrow if it's not this known issue
      throw e;
    }






    if (result.appState?.postLoginAction === "upgrade_pro") {
      window.location.href = "/pricing?upgrade=true";
    }

  }

  static stageAuth$OnReturnedRedirect(){
    const url = new URL(window.location.href);
    if (url.searchParams.get("upgrade") === "true") {
      //stageAuth$StartUpgradeFlow();
    }

  }


  static async stageAuth$AcceptTermsAndContinue(idToken, user) {
    const {sub} = user;
   //console.log("AUTH AND USER IN STAGE LINKS5 ", this.props, {sub,user})

    try {
      // 1. Get Auth0 idToken using same pattern as manage settings flow

      // 2. Make request to Lambda
      const res = await fetch(updateTOSURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${idToken}`
        },
        body: JSON.stringify({ userSub:sub })
      });

      if (!res.ok) {
        throw new Error(`Server responded with ${res.status}`);
      }

      const result = await res.json();
     //console.log("TOS accepted:", result);

      const channel = "CHANNEL_MODAL_WINDOW";
      const action = "CHANNEL_MODAL_WINDOW_CLOSE_REQUEST_EVENT";
      const modalType = 'tos';
      this.sendInfoToChannel(channel, {action,modalType}, action);

      // 4. Proceed to app
     //console.log("User may now proceed to the app.");

    } catch (err) {
      console.error("Error accepting terms:", err);
      alert("There was an issue accepting the Terms of Service. Please try again.");
    }
  }

  static async stageAuth$StartManageSettingsFlow() {
    const {auth0} = this.props;
    const idToken = (await auth0.getIdTokenClaims()).__raw;

    const res = await fetch(stripeManageSettingsURL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    const data = await res.json();

    // Redirect browser into Stripe portal
    window.location.href = data.url;

  }



  static async stageAuth$StartUpgradeFlow(token) {
    const {auth0} = this.props;

    const res = await fetch(stripeCheckoutSessionURL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        origin: window.location.origin
      })
    });



    const { url } = await res.json();

   //console.log('stripe url is ', {url, token, auth0, stripeCheckoutSessionURL});
    window.location.href = url;   // Redirect to Stripe Checkout


  }



}

